import { v4 as uuidv4 } from 'uuid';
import type {
    OnboardingApplicationLogsPaginator,
    OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges
} from "../types";

export const addUniqueId = ({ data, ...paginator }: OnboardingApplicationLogsPaginator<
    Record<
        string,
        OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges[]
    >
>) => ({
    ...paginator,
    data: Object.entries(data)
        .reduce((acc, [key, value]) => ({
            ...acc,
            [key]: value.map(entry => ({
                ...entry,
                coreId: uuidv4()
            }))
        }), {})
});
